import { SharedChakraProvider } from '@erinaceus/ui'

const theme = {
  components: {
    Table: {
      variants: {
        simple: {
          th: {
            borderColor: 'primary.100',
          },
          td: {
            borderColor: 'primary.50',
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        overlay: {
          // baseStyle: {
          // bg: 'blackAlpha.300',
          backdropFilter: 'blur(5px)',
          // },
        },
      },
    },
  },
}

const ChakraProvider = ({ children }) => {
  return <SharedChakraProvider theme={theme}>{children}</SharedChakraProvider>
}

export default ChakraProvider
